export var TopicStage;
(function (TopicStage) {
    TopicStage["Unspecified"] = "";
    TopicStage["Late"] = "Late";
    TopicStage["Early"] = "Early";
})(TopicStage || (TopicStage = {}));
export var topicStageOptions = ['Early', 'Late'].map(function (value) { return ({
    value: value,
    label: value,
}); });
//# sourceMappingURL=TopicStage.js.map